import AbstractCouponEvent from "./AbstractCouponEvent";

export default class CartCouponEnteredEvent extends AbstractCouponEvent {
    static readonly eventName: string = "CartCouponEntered";

    getName(): string {
        return CartCouponEnteredEvent.eventName;
    }
}
